import React from "react";
import useDimensions from "../hooks/useDimensions";

const SignaturePosition = ({
  position,
  onSignatureClick,
  onRemoveSign,
  containerRef,
}) => {
  const pdf = useDimensions(containerRef);

  if (!position) return null;

  return (
    <div
      className={`ps-signature-box ${
        position.signature ? "signed" : "unsigned"
      }`}
      style={{
        left: `${position.normalizedX * pdf.width}px`,
        top: `${position.normalizedY * pdf.height}px`,
      }}
    >
      {position.signature ? (
        <>
          <div className="ps-signed-img-wrapper">
            <img
              src={position.signature}
              alt="Signature"
              className="ps-signed-img"
            />
            <button
              className="ps-remove-sign-btn"
              onClick={onRemoveSign}
              title="Remove signature"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </button>
          </div>
          <div className="ps-signature-timestamp">{position.timestamp}</div>
        </>
      ) : (
        <button
          className="ps-button blue ps-add-signature-btn"
          onClick={() => onSignatureClick(position)}
        >
          Add Signature
        </button>
      )}
    </div>
  );
};

export default SignaturePosition;
